export default __webpack_public_path__ + "static/media/Tokenomics.8fc09b11.png";